import request from "@/utils/request";

//  请求打印列表
export const printList = data => {
  return request({
    url: "/treasure/print/cloud/api/print/getDataList",
    method: "POST",
    data
  });
};

// 获取预览文件流
export const getFileStream = data => {
  return request({
    url: "/treasure/print/cloud/api/print/downLoadFile",
    method: "POST",
    data
  });
};

// 发送到打印机
export const sendPrint = data => {
  return request({
    url: "/treasure/print/cloud/api/print/uploadFile",
    method: "POST",
    data
  });
};

// 检查是否发送成功

export const isPrinted = data => {
  return request({
    url: "/treasure/print/cloud/api/print/getResult",
    method: "POST",
    data
  });
};
